export const permissions = {
  canViewExecutiveReports: "canViewExecutiveReports",
  canViewConnectReports: "canViewConnectReports",
  canDownloadConnectRawData: "canDownloadConnectRawData",
  canCreateManualCase: "canCreateManualCase",
  canViewPaySlip: "canViewPaySlip",

  canManageSurveys: "canManageSurveys",
  canViewSurveyReport: "canViewSurveyReport",
  canDownloadSurveyRawData: "canDownloadSurveyRawData",
  canManageQuestionnaires: "canManageQuestionnaires",
  canViewQuestionnaireReport: "canViewQuestionnaireReport",
  canDownloadQuestionnaireRawData: "canDownloadQuestionnaireRawData",
  canCreateQuestionnaires: "canCreateQuestionnaires",

  canViewELearningReports: "canViewELearningReports",
  canDownloadELearningThisPageXLS: "canDownloadELearningThisPageXLS",
  canDownloadELearningRawData: "canDownloadELearningRawData",

  canViewCompanyPostReports: "canViewCompanyPostReports",
  canDownloadCompanyPostRawData: "canDownloadCompanyPostRawData",

  canManageWorkerContacts: "canManageWorkerContacts",
  canManageAccounts: "canManageAccounts",

  canManageRoles: "canManageRoles",
  canManageUsers: "canManageUsers",

  canBulkEditCustomFields: "canBulkEditCustomFields",

  canViewDownloads: "canViewDownloads",
};

export const downloadPermissions = Object.keys(permissions)
  .filter((key) => key.startsWith("canDownload"))
  .map((key) => permissions[key]);
